import { createSelector } from 'reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

const selectedShiftStatusFiltersSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (facilityViewState) => facilityViewState.selectedShiftStatusFilters,
);

export default selectedShiftStatusFiltersSelector;
